import {
  AfterViewInit,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import Player from '@vimeo/player';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ChildMenuNavigationItem, MainMenuNavigationItem, MenuItems } from '../../shared/menu-items/menu-items';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import PerfectScrollbar from 'perfect-scrollbar';

import {
  AuthenticationService,
  ClientService,
  ConfigService,
  DashboardService,
  EventsService,
  InsightsService,
  SurveyFiltersService
} from '@services/services.module';

import { AppCache } from '../../components/survale-common/cache/app.cache';

import * as _ from 'lodash';
import * as moment from 'moment';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import {
  AddedDashboard,
  DeletedDashboard,
  EventsServiceDateRange,
  ReloadObjectTypes
} from '@services/events.service';
import { AppFeatures, PermissionOptions, PermissionTypes } from '@services/config.service';
import { SurvaleCommonComponent } from '../../common/survale-common.component';
import { TwoFaCodeComponent } from '../../screens/admin/users/two-fa-code/two-fa-code.component';
import { MatDialog } from '@angular/material/dialog';
import { SideMenuService } from '../../components/side-menu/side-menu.service';

@Component({
  selector: 'app-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
  standalone: false
})
export class AdminLayoutComponent extends SurvaleCommonComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild(DaterangepickerDirective) pickerDirective: DaterangepickerDirective;

  @ViewChild('sidemenu', { static: true }) sidemenu;

  // finalMenuItems: MainMenuNavigationItem[] = [];
  public config: any = {};
  public survaleMainLogo = 'assets/survale-enterprise.png';
  public beLogo = '';

  today: number = Date.now();
  url: string;
  showSettings = false;
  dark: boolean;
  boxed: boolean;
  collapseSidebar: boolean;
  compactSidebar: boolean;
  horizontal = false;
  sidebarBg = true;
  currentLang = 'en';
  layoutDir = 'ltr';
  searchFocus = false;
  menuLayout: any = 'vertical-menu';
  selectedSidebarImage: any = 'bg-1';
  selectedSidebarColor: any = 'sidebar-default';
  selectedHeaderColor: any = 'header-default';
  collapsedClass: any = 'side-panel-opened';
  logoUrl = 'https://static.survale.com/images/survale-clear-image.png';
  avatar: string;
  userName: string;
  selectedDateRange = { startDate: moment(), endDate: moment() };
  candeMenuClicked = false;
  dateRangePickerOptions: any;
  forceHideSideMenu = false; // only used by screenshot component
  calendarSettings: boolean;

  private _router: Subscription;
  private userViews: any[] = [];
  private insights: any[] = [];
  private dashboards: any[] = [];
  private employeeCampaigns: any[] = [];
  private surveyFilters: any = [];
  private selfDashboardFilters: any = [];
  private cache = AppCache.getInstance();
  private cacheTypes = AppCache.cacheTypes();
  private enableDateRangeEventEmitter = false;
  private menuCheckerCount = 0;
  private subscriptions: Array<Subscription> = [];



  constructor(
    public authenticationService: AuthenticationService,
    private router: Router,
    public menuItems: MenuItems,
    public translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private insightsService: InsightsService,
    private surveyFiltersService: SurveyFiltersService,
    private configService: ConfigService,
    private clientService: ClientService,
    public dialog: MatDialog,
    private eventsService: EventsService,
    private dashboardService: DashboardService,
    private sideMenuService: SideMenuService) {
    // console.log('AdminLayoutComponent loaded');
    super(authenticationService);
    this.clientService.getClientSettings().subscribe((data) => {
      const clientSettings = JSON.parse(data.body[0].clientSettings);
      this.calendarSettings = clientSettings.calendarQuartersDisabled;
      this.dateRangePickerOptions = this.configService.getDateRangePickerOptions(this.calendarSettings);
    });

    // console.log('AdminLayoutComponent .. ctor');
    const currentDateRange = this.eventsService.getCurrentDateRange();
    // const currentDateRangeLabel = this.eventsService.getCurrentDateRangeLabel();

    this.selectedDateRange.startDate = currentDateRange.startDate;
    this.selectedDateRange.endDate = currentDateRange.endDate;

    this.subscriptions.push(this.eventsService.onDashboardAdded$
      .subscribe((d: AddedDashboard): void =>
        this.addDashboardToView(d.id, d.viewId, d.title, d.dashboard)
      )
    );

    this.subscriptions.push(this.eventsService.onDashboardDeleted$
      .subscribe((d: DeletedDashboard): void =>
        this.removeDashboardFromView(d.id, d.viewId)
      )
    );
    this.subscriptions.push(this.eventsService.onReloadObject$
      .subscribe((objType: ReloadObjectTypes): void => {
        if (objType === ReloadObjectTypes.Insights) {
          this.insightsService.getUsersSurveyInsights()
            .subscribe((response): void => {
              this.processInsights(response.body);
            });
          // } else if (objType === ReloadObjectTypes.SurveyFilters) {
          //   this.surveyFiltersService.getUsersSurveyFilters()
          //     .subscribe(response => {
          //       this.processSurveyFilters(response.body);
          //     })
          // } else if (objType === ReloadObjectTypes.DashboardFilters) {
          //   this.dashboardService.getSelfFilteredDashboards()
          //     .subscribe((data) => {
          //       this.processSelfDashboardsFilters(data.body);
          //     })
        }
      }));

    this.subscriptions.push(this.eventsService.onEventDateRangeChanged$.subscribe((dateRange: EventsServiceDateRange): void => {
      this.selectedDateRange = dateRange;
    }));

    this.subscriptions.push(this.eventsService.onForceDateRange$.subscribe((dateRange: EventsServiceDateRange): void => {
      this.selectedDateRange = dateRange;
      this.eventsService.emitDateRangeChanged(dateRange);
    }));

    this.subscriptions.push(this.eventsService.readyComponentsForScreenshot$.subscribe((): void => {
      // console.log('hiding side menu');
      this.collapsedClass = 'side-panel-closed';
      this.sidemenu.opened = false;
      this.forceHideSideMenu = true;
      setTimeout((): boolean => window.dispatchEvent(new Event('resize')), 2000);
      // this fires resize event to adjust the content
      this.eventsService.emitSideToggled$();

    }));

    this.subscriptions.push(this.eventsService.onSelfDashboardFiltersChanged.subscribe((): void => {
      // repopulate the list
      this.dashboardService.getSelfFilteredDashboards()
        .subscribe((data) => {
          this.processSelfDashboardsFilters(data.body);
        });
    }));

    this.eventsService.onSelfSurveyFiltersChanged.subscribe((): void => {
      this.surveyFiltersService.getUsersSurveyFilters()
        .subscribe((data) => {
          this.processSurveyFilters(data.body);
        });
    });

    // Re-evaluate menu visibility whenever the current user changes - in particular, this picks up
    // Features Enabled toggles saved from Admin > Client > Settings without requiring re-login
    // (see AuthenticationService.updateCurrentUser()).
    this.subscriptions.push(this.authenticationService.onCurrentUserChanged$.subscribe((): void => {
      this.setMenuItemsVisibility();
    }));
    switch (window.location.hostname) {
      // case 'localhost':
      case 'pro.survale.com':
      case 'be.survale.com':
        this.survaleMainLogo = 'assets/images/survale-pro-white.png';
        // const product = _.get(this.currentUser, 'clientSettings.beDeploymentDetails.product');
        // if (product) {
        //   this.beLogo = `assets/logo/${product}.jpg`;
        // }
        break;
      case 'surveys.e360data.com':
        this.survaleMainLogo = 'assets/partner-logos/demo-logo.png';
        break;
      case 'surveys.radancy.solutions':
        this.survaleMainLogo = 'assets/partner-logos/radancy.png';
        break;
      case 'surveys.phenomsurveys.com':
        this.survaleMainLogo = 'assets/partner-logos/phenom.png';
        break;
      case 'surveys.happydance.solutions':
        this.survaleMainLogo = 'assets/partner-logos/happy-dance.png';
        break;
      default:
        if (this.isCande()) {
          this.survaleMainLogo = 'assets/survale-lite-logo.png';
        } else {
          this.survaleMainLogo = 'assets/survale-enterprise.png';
        }
        break;
    }


  }

  @HostListener('click', ['$event'])
  onClick(e: any) {
    const elemSidebar = <HTMLElement>document.querySelector('.sidebar-container ');
    setTimeout((): void => {
      if (window.matchMedia('(min-width: 960px)').matches && !this.isMac() && !this.compactSidebar && this.layoutDir !== 'rtl') {
        new PerfectScrollbar(elemSidebar, {
          wheelSpeed: 2,
          suppressScrollX: true
        });
      }
    }, 350);
  }

  ngOnInit(): void {

    // TODO: based on current user set the logo url
    // https://static.survale.com/images/survale-limited-logo.png
    const elemSidebar = <HTMLElement>document.querySelector('.sidebar-container ');
    // @ts-ignore
    if (window.matchMedia('(min-width: 960px)').matches && !this.isMac() &&
      !this.compactSidebar && this.layoutDir.toString() !== 'rtl') {
      const ps = new PerfectScrollbar(elemSidebar, {
        wheelSpeed: 2,
        suppressScrollX: true
      });
    }

    this._router = this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.url = event.url;
        if (this.isOver()) {
          this.sidemenu.close();
        }
        // @ts-ignore
        if (window.matchMedia('(min-width: 960px)').matches &&
          !this.isMac() && !this.compactSidebar && this.layoutDir.toString() !== 'rtl') {
          // Ps.update(elemContent);
        }
      });

    this.activatedRoute.data.subscribe(response => {
      this.processResolversData(response);
    });
    const suppressProductFruitZIndex = (): void => {
      const elements = Array.from(document.querySelector('.productfruits--container')
        ?.shadowRoot
        ?.querySelectorAll('.productfruits--context-help-help-icon') || []);
      for (const elem of elements) {
        // @ts-ignore
        elem.style['z-index'] = '1';
      }
    };
    setTimeout(suppressProductFruitZIndex, 1000);
    setTimeout(suppressProductFruitZIndex, 5000);
    setTimeout(suppressProductFruitZIndex, 10000);


  }

  ngAfterViewInit(): void {
    this.enableDateRangeEventEmitter = true;
  }

  ngOnDestroy(): void {
    if (this._router) {
      this._router.unsubscribe();
    }
    _.each(this.subscriptions, (s: Subscription): void => s.unsubscribe());
  }

  processResolversData(response: any): void {
    try {
      // console.log('loadData response: ', response);
      this.processViews(response.views.body);
      this.processInsights(response.insights.body);
      this.processUserDashboards(response.userDashboards.body);
      this.processEmployeeCampaigns(response.employeeCampaigns.body);
      this.processSurveyFilters(response.surveyFilters.body);
      this.processSelfDashboardsFilters(response.selfDashboardsFilters.body);
      this.setMenuItemsVisibility();
    } catch (error) {
      console.error('Error processing resolvers data', error);
    }
  }

  setMenuItemsVisibility(): void {
    this.avatar = this.currentUser.avatar;
    this.userName = this.currentUser.userName.replace('null', '');
    _.each(this.menuItems.getAll(), mi => {
      // go through the permissions and set visibility
      this.setMenuItemVisibility(mi);
    });
    // hide toolkit if children are 0
    // console.log('menuitems ', this.menuItems.getAll());
    _.each(['toolkit', 'admin'], mi => {
      const m = _.find(this.menuItems.getAll(), i => i.state === mi);
      if (!m) { return; }
      m.visible = _.compact(_.map(m.children, c => c.visible)).length > 0;
      // special case for pro version
      if (m.state === 'url-shortener' && this.isBE() && !this.isSurvaleAdmin) {
        m.visible = false;
      }
    });
    this.overrideVisibility();

    // for BE version
    if (this.isBE() && !this.isSurvaleAdmin) {
      const toolkitMenu = _.find(this.menuItems.getAll(), i => i.state === 'toolkit');
      if (toolkitMenu) {
        const viewsMenu = _.find(toolkitMenu.children, (i): boolean => i.state === 'views');
        if (viewsMenu) { viewsMenu.visible = false; }
        const urlShortenerMenu = _.find(toolkitMenu.children, (i): boolean => i.state === 'url-shortener');
        if (urlShortenerMenu) { urlShortenerMenu.visible = false; }
      }
      const settingsMenu = _.find(this.menuItems.getAll(), i => i.state === 'be-settings');
      if (settingsMenu) { settingsMenu.visible = true; }

      // console.log('this.menuItems ', this.menuItems.getAll());
    }
    // this.finalMenuItems = _.cloneDeep(this.menuItems.getAll());
  }

  setMenuItemVisibility(item: MainMenuNavigationItem | ChildMenuNavigationItem): void {

    const currentUser = this.authenticationService.getCurrentUser();
    item.visible = (this.isSurvaleAdmin ||
      (_.isNil(item.permission) ? true : this.hasPermission(item.permission, PermissionOptions.View)));

    if (!_.isNil(item.requiresSurvaleAdmin)) {
      item.visible = item.visible && currentUser.isSurvaleAdmin;
    }

    if (item.name === 'Join CandE Community' || item.name === 'Survale Lite CandE Tutorial') {
      item.visible = this.isCande();
    }
    // console.log('>>> item :: ', item.name, item.visible);

    if (currentUser.clientSource === 'CANDE-MAIN') {
      _.each(this.userViews, v => {
        const viewDashboards = this.cache.getCache(this.cacheTypes.ViewDashboards, v.viewId);
        if (viewDashboards && viewDashboards.body) {
          const filteredDashboards =
            _.filter(viewDashboards.body, dashboard => item.name === dashboard.title && item.state === dashboard.id);
          if (filteredDashboards.length > 0) {
            item.visible = false;
          }
        }
      });
    }

    if (item.children && item.children.length > 0) {
      _.each(item.children, (child: ChildMenuNavigationItem) => this.setMenuItemVisibility(child));
    }
  }

  // redirectUser() {
  // console.log('redirecting user');
  // const viewsMenu = _.find(this.menuItems.getAll(), i => i.state === 'views');
  // console.log('viewsMenu', ( viewsMenu));
  // if (viewsMenu.children.length > 0) {
  //   // @ts-ignore
  //   const dashboardId = viewsMenu.children[0].children[1].state;
  //   const viewId = viewsMenu.children[0].state;
  //   // console.log('::this.router.url', viewId, dashboardId, this.router.url);
  //   setTimeout((): void => {
  //     console.log('redirecting to dashboard', this.router.url);
  //     if (this.router.url === '' || this.router.url === '/home') {
  //       // redirect to dashboard if url is blank
  //       this.navigateTo(this.router, ['/', 'views', viewId, 'dashboard', dashboardId])
  //     }
  //   }, 1000)
  // } else {
  //   // insight user
  //   const insightsMenu = _.find(this.menuItems.getAll(), i => i.state === 'insights');
  //   if (insightsMenu.children.length === 0) {
  //     // menu's have not loaded
  //     this.menuCheckerCount++;
  //     if (this.menuCheckerCount > 10) {
  //       console.log('exceeded');
  //     } else {
  //       setTimeout((): void => this.redirectUser(), 1000);
  //     }
  //     return;
  //   }
  //   const insightId = insightsMenu.children[0].state;
  //   console.log('redirecting to insight', this.router.url, insightId);
  //   setTimeout((): void => {
  //     if (this.router.url === '' || this.router.url === '/home') {
  //       // redirect to dashboard if url is blank
  //       this.navigateTo(this.router, ['/', 'insights', insightId])
  //     }
  //   })
  // }
  // }

  addDashboardToView(id: number, viewId: number, title: string, dashboard: any): void {
    const viewsMenu = _.find(this.menuItems.getAll(), i => i.state === 'views');
    if (!viewsMenu) { return; }
    const viewMenuItem: any = _.find(viewsMenu.children, (v: any) => v.data.viewId === viewId);
    const dashboardMenuItem = {
      state: id,
      name: title,
      data: dashboard,
      type: 'link',
      children: []
    };
    const exists = _.find(dashboardMenuItem, dmi => dmi.state === id);
    if (!exists) {
      viewMenuItem.children.push(dashboardMenuItem);
    }
    // this.finalMenuItems = _.cloneDeep(this.menuItems.getAll());
  }

  removeDashboardFromView(id: number, viewId: number): void {
    const viewsMenu: any = _.find(this.menuItems.getAll(), i => i.state === 'views');
    const viewMenuItem: any = _.find(viewsMenu.children, (v: any) => v.data.viewId === viewId);
    const deleteIndex = _.findIndex(viewMenuItem.children, (c: any) => c.state === id);
    viewMenuItem.children.splice(deleteIndex, 1);
  }

  processViews(userViews: any): void {
    try {
      this.userViews = userViews;
      // console.log('getViewsForUser response', userViews);
      const viewsMenu = _.find(this.menuItems.getAll(), i => i.state === 'views');
      if (!viewsMenu) { return; }
      viewsMenu.children = viewsMenu.children || [];
      const allViewsMenuItems = [];
      if (_.isNil(this.userViews)) {
        return;
      }
      for (const v of this.userViews) {
        const viewMenuItem: MainMenuNavigationItem = {
          state: v.viewId.toString(),
          name: v.viewName,
          data: v, // this is probably not needed
          type: 'link',
          children: [],
          visible: true,
        };
        //   // cache should have all the dashboards for views
        const viewDashboards = this.cache.getCache(this.cacheTypes.ViewDashboards, v.viewId);
        if (viewDashboards && viewDashboards.body) {
          // _.each(viewDashboards.body, dashboard => {
          for (const dashboard of viewDashboards.body) {
            if (typeof (dashboard.dashboardJSON) === 'string') {
              dashboard.dashboardJSON = JSON.parse(dashboard.dashboardJSON);
            }
          }
          // });
          const dashboardMenuItems = [];
          if (ConfigService.config.loadDashboardsInMenu) {
            for (const dashboard of viewDashboards.body) {
              const dashboardMenuItem: MainMenuNavigationItem = {
                state: dashboard.id.toString(),
                name: dashboard.title,
                data: dashboard, // this is probably not needed
                type: 'link',
                children: [],
                visible: true
              };
              const currentUser = this.authenticationService.getCurrentUser();
              if (currentUser.clientSource === 'CANDE-MAIN') {
                dashboardMenuItem.visible = false;
              }
              dashboardMenuItems.push(dashboardMenuItem);
            }
            // console.log('dashboardMenuItems', dashboardMenuItems);
            if (dashboardMenuItems.length > 0) {
              // >> PROBLEM HERE <<<
              // viewMenuItem.children.splice(viewMenuItem.children.length - 1, 0, dashboardMenuItems);
              // console.log('viewMenuItem.children', viewMenuItem.children);
              viewMenuItem.children = (viewMenuItem.children || []).concat(dashboardMenuItems);
            }
          } else {
            if (viewDashboards.body.length === 1) {
              const dashboard = viewDashboards.body[0];
              const dashboardMenuItem: MainMenuNavigationItem = {
                state: String(dashboard.id),
                name: dashboard.title,
                data: dashboard,
                type: 'link',
                children: [],
                visible: true
              };
              viewMenuItem.children?.push(dashboardMenuItem);

            } else {
              const menuItem: MainMenuNavigationItem = {
                state: 'dashboards',
                name: 'Dashboards',
                type: 'link',
                children: [],
                visible: true
              };
              viewMenuItem.children?.push(menuItem);
            }
          }
          const viewMenuItemChildren = viewMenuItem.children;
          if (viewMenuItemChildren && viewMenuItemChildren.length > 1) {
            // move Main dashboard to top
            for (const dashboardName of ['Main Dashboard', 'Default Dashboard']) {
              const idx = _.findIndex(viewMenuItemChildren, (c): boolean => c.name === dashboardName);
              if (idx > 0) {
                viewMenuItemChildren.unshift(viewMenuItemChildren.splice(idx, 1)[0]);
              }
            }
          }
          const aiSettings = _.get(this.currentUser, 'clientSettings.aiSettings');
          // console.log('aiSettings', aiSettings);

          if ((this.isFeatureEnabled(AppFeatures.SentimentAnalysis, false)) &&
            !this.isFeatureHidden(AppFeatures.SentimentAnalysis)) {
            if (aiSettings?.sentimentAnalysis && aiSettings?.enableAI) {
              const sentimentAnalysis2MenuItem: MainMenuNavigationItem = this.sentimentAnalysis2MenuItem();
              viewMenuItem.children?.unshift(sentimentAnalysis2MenuItem); // second item is survey-analysis
            } else if (!this.isCande()) {
              const sentimentAnalysisMenuItem: MainMenuNavigationItem = this.sentimentAnalysisMenuItem();
              viewMenuItem.children?.unshift(sentimentAnalysisMenuItem); // second item is survey-analysis
            }
          }

          if ((this.isFeatureEnabled(AppFeatures.QBR, false)) &&
            !this.isCande() && !this.isFeatureHidden(AppFeatures.QBR)
            && (this.hasPermission(PermissionTypes.TalentImpact, PermissionOptions.View) || this.isSurvaleAdmin)
          ) {
            const surveyAnalysisMenuItem: MainMenuNavigationItem = this.surveyAnalysisMenuItem();
            viewMenuItem.children?.unshift(surveyAnalysisMenuItem);
          }

          if ((this.isFeatureEnabled(AppFeatures.FlaggedComments, false))) {
            if (aiSettings?.analyzeCommentsLegality && aiSettings?.enableAI &&
              (this.hasPermission(PermissionTypes.FlaggedComments, PermissionOptions.View) || this.isSurvaleAdmin)) {
              const legallyConcerningCommentsMenuItem: MainMenuNavigationItem = this.flaggedCommentsLegal2MenuItem();
              viewMenuItem.children?.unshift(legallyConcerningCommentsMenuItem);
            }
            // else if (!this.isCande()) {
            //   const legallyConcerningCommentsMenuItem: MainMenuNavigationItem = this.flaggedCommentsLegalMenuItem();
            //   viewMenuItem.children.unshift(legallyConcerningCommentsMenuItem);
            // }
          }

          const surveysMenuItem: MainMenuNavigationItem = this.surveysMenuItem();
          viewMenuItem.children?.unshift(surveysMenuItem); // first item is surveys
          viewMenuItem.type = (viewMenuItem.children?.length ?? 0) > 0 ? 'sub' : 'link';
          allViewsMenuItems.push(viewMenuItem);
          // viewsMenu.children.push(viewMenuItem);
        }
      }

      // console.log('allViewsMenuItems', allViewsMenuItems, allViewsMenuItems.slice(0, 2));
      // >> PROBLEM HERE <<< <<<
      viewsMenu.children = allViewsMenuItems; // .slice(0, 2);
      // this.finalMenuItems = _.cloneDeep(this.menuItems.getAll());

      const routePath = this.router.url.split('/');
      // console.log(`routePath - ${routePath}`);
      if (routePath[1] === 'home') {
        if (viewsMenu.children.length > 0) {
          // Expand the Views section and the default/current view sub-section
          const viewId = routePath[2] || viewsMenu.children[0].state;
          setTimeout((): void => {
            this.sideMenuService.expandSection('views');
            this.sideMenuService.expandSection(String(viewId));
          }, 100);
        } else {
          // Insight-only user: expand the Insights section
          setTimeout((): void => {
            this.sideMenuService.expandSection('insights');
            this.sideMenuService.expandSection('dashboards');
          }, 100);
        }
      } else if (routePath[1] === 'insights') {
        setTimeout((): void => {
          this.sideMenuService.expandSection('insights');
        }, 100);
      } else if (routePath[1] === 'dashboards') {
        setTimeout((): void => {
          this.sideMenuService.expandSection('dashboards');
        }, 100);
      } else {
        // Generic: expand the top-level section and, if present, a level-2 sub-section
        setTimeout((): void => {
          this.sideMenuService.expandSection(routePath[1]);
          if (routePath[2]) {
            this.sideMenuService.expandSection(routePath[2]);
          }
        }, 100);
      }
    } catch (error) {
      console.error('Error processing views', error);
    }
  }

  public sentimentAnalysisMenuItem(): MainMenuNavigationItem {
    return {
      state: 'sentiment-analysis',
      name: 'Sentiment Analysis',
      type: 'link',
      children: [],
      permission: PermissionTypes.SentimentAnalysis,
      visible: true
    };
  }

  public sentimentAnalysis2MenuItem(): MainMenuNavigationItem {
    return {
      state: 'sentiment-analysis-2',
      name: 'Sentiment Analysis',
      type: 'link',
      children: [],
      permission: PermissionTypes.SentimentAnalysis,
      visible: true
    };
  }

  public surveyAnalysisMenuItem(): MainMenuNavigationItem {
    return {
      state: 'survey-analysis',
      name: 'Talent Impact',
      type: 'link',
      permission: PermissionTypes.TalentImpact,
      children: [],
      visible: true
    };
  }

  public flaggedCommentsLegalMenuItem(): MainMenuNavigationItem {
    return {
      state: 'flagged-comments',
      additionalStates: ['legal'],
      name: 'Flagged Comments',
      type: 'link',
      permission: PermissionTypes.FlaggedComments,
      children: [],
      visible: true
    };
  }

  public flaggedCommentsLegal2MenuItem(): MainMenuNavigationItem {
    return {
      state: 'flagged-comments',
      additionalStates: ['legal-2'],
      name: 'Flagged Comments',
      type: 'link',
      permission: PermissionTypes.FlaggedComments,
      children: [],
      visible: true
    };
  }

  public surveysMenuItem(): MainMenuNavigationItem {
    return {
      state: 'surveys',
      name: 'Surveys',
      type: 'link',
      children: [],
      visible: true,
      customCssClass: 'nuii-pf-surveys'
    };
  }

  processInsights(insights) {
    // console.log('insights', insights);
    this.insights = insights;
    const menuItems = this.menuItems.getAll();
    const insightsMenuItem = _.find(menuItems, i => i.state === 'insights');
    if (!insightsMenuItem) { return; }
    insightsMenuItem.children = [];
    // @ts-ignore
    _.each(this.insights, v => insightsMenuItem.children.push({ state: v.insightId, name: v.insightName, data: v }));
    insightsMenuItem.visible = this.insights.length > 0;
    // this.finalMenuItems = _.cloneDeep(this.menuItems.getAll());
  }

  overrideVisibility() {
    const menuItems = this.menuItems.getAll();
    const insightsMenuItem = _.find(menuItems, (i): boolean => i.state === 'insights');
    if (insightsMenuItem) { insightsMenuItem.visible = this.insights.length > 0; }
    const userDashboardsMenuItem = _.find(menuItems, (i): boolean => i.state === 'dashboards');
    if (userDashboardsMenuItem) { userDashboardsMenuItem.visible = this.dashboards.length > 0; }
    const viewsMenuItem = _.find(menuItems, (i): boolean => i.state === 'views');
    if (viewsMenuItem) { viewsMenuItem.visible = this.userViews?.length > 0; }
    const settingsMenuItem = _.find(this.menuItems.getAll(), (i): boolean => i.state === 'be-settings');
    if (settingsMenuItem) { settingsMenuItem.visible = false; }
    const employeeCampaignResultsMenuItem = _.find(menuItems, (i): boolean => i.state === 'employee-campaign-results');
    if (employeeCampaignResultsMenuItem) {
      employeeCampaignResultsMenuItem.visible = (this.hasPermission(PermissionTypes.EmployeeCampaignResults) || this.isSurvaleAdmin) &&
        this.employeeCampaigns.length > 0 &&
        this.isFeatureEnabled(AppFeatures.EmployeeCampaigns, false);
    }
    const toolkitMenuItem = _.find(menuItems, (i): boolean => i.state === 'toolkit');
    const toolkitEmployeeCampaignsItem = _.find(toolkitMenuItem?.children, (i): boolean => i.state === 'employee-campaigns');
    if (toolkitEmployeeCampaignsItem) {
      toolkitEmployeeCampaignsItem.visible = toolkitEmployeeCampaignsItem.visible &&
        this.isFeatureEnabled(AppFeatures.EmployeeCampaigns, false);
    }
    const toolkitEmployeeListsItem = _.find(toolkitMenuItem?.children, (i): boolean => i.state === 'employee-lists');
    if (toolkitEmployeeListsItem) {
      toolkitEmployeeListsItem.visible = toolkitEmployeeListsItem.visible &&
        this.isFeatureEnabled(AppFeatures.EmployeeCampaigns, false);
    }
    const reportsMenuItem = _.find(menuItems, (i): boolean => i.state === 'reports');
    const reportsEmployeeCampaignsItem = _.find(reportsMenuItem?.children, (i): boolean => i.state === 'employee-campaigns');
    if (reportsEmployeeCampaignsItem) {
      reportsEmployeeCampaignsItem.visible = reportsEmployeeCampaignsItem.visible &&
        this.isFeatureEnabled(AppFeatures.EmployeeCampaigns, false);
    }
    const filterMenuItem = _.find(menuItems, (i): boolean => i.state === 'saved-user-filters');
    if (filterMenuItem) { filterMenuItem.visible = this.surveyFilters.length > 0 || this.selfDashboardFilters.length > 0; }
    // this.finalMenuItems = _.cloneDeep(this.menuItems.getAll());
  }

  processUserDashboards(dashboards) {
    // console.log('dashboards', dashboards);
    this.dashboards = dashboards;
    const menuItems = this.menuItems.getAll();
    const menuItem = _.find(menuItems, i => i.state === 'dashboards');
    if (!menuItem) { return; }
    menuItem.children = [];
    _.each(this.dashboards, (v) => menuItem.children?.push({
      visible: true,
      state: v.dashboardId,
      // subState: v.shareId,
      name: v.dashboardTitle,
      data: v
    }));
    menuItem.visible = this.dashboards.length > 0;
    // console.log('processUserDashboards', menuItem);
    // this.finalMenuItems = _.cloneDeep(this.menuItems.getAll());
  }


  processEmployeeCampaigns(employeeCampaigns: any): void {
    // console.log('insights', insights);
    this.employeeCampaigns = employeeCampaigns.campaigns;
    const menuItems = this.menuItems.getAll();
    const employeeCampaignsMenuItem = _.find(menuItems, i => i.state === 'employee-campaign-results');
    if (!employeeCampaignsMenuItem) { return; }
    employeeCampaignsMenuItem.children = [];
    _.each(this.employeeCampaigns, (v: any): void => {
      employeeCampaignsMenuItem.children?.push({ visible: true, state: v.id, name: v.title, data: v });
    });
    employeeCampaignsMenuItem.visible = (this.employeeCampaigns || []).length > 0;
    // this.finalMenuItems = _.cloneDeep(this.menuItems.getAll());
  }

  processSurveyFilters(surveyFilters: any): void {
    this.surveyFilters = surveyFilters;
    this.processSavedUserFiltersMenu();
  }

  processSelfDashboardsFilters(selfDashboardFilters: any): void {
    this.selfDashboardFilters = selfDashboardFilters;
    this.processSavedUserFiltersMenu();
  }

  processSavedUserFiltersMenu(): void {
    const menuItems = this.menuItems.getAll();
    const filterMenuItem = _.find(menuItems, (i: any): boolean => i.state === 'saved-user-filters');
    if (_.isNil(filterMenuItem)) {
      return;
    }
    filterMenuItem.children = [];
    if (this.surveyFilters.length > 0) {
      const surveysMI: MainMenuNavigationItem = {
        visible: true,
        state: 'survey-insights',
        name: 'Surveys/Insights',
        children: [],
        type: 'sub',
      };
      filterMenuItem.children.push(surveysMI);
      // console.log('this.surveyFilters', this.surveyFilters);
      _.each(this.surveyFilters, (v: any) => surveysMI.children.push({
        visible: true,
        state: v.id,
        name: v.filterName,
        data: v
      }));
    }
    if (this.selfDashboardFilters.length > 0) {
      const dashboard: MainMenuNavigationItem = {
        visible: true,
        state: 'dashboards',
        name: 'Dashboards',
        children: [],
        type: 'sub',
      };
      filterMenuItem.children.push(dashboard);
      // console.log('this.selfDashboardFiltersFilters', this.selfDashboardFilters);
      _.each(this.selfDashboardFilters, (v: any) => dashboard.children.push({
        visible: true,
        state: v.dashboardId,
        additionalStates: [(v.filtered_dashboard_id || '-1'), v.id.toString()],
        name: v.title,
        data: v
      }));
    }
    filterMenuItem.visible = this.surveyFilters.length > 0 || this.selfDashboardFilters.length > 0;
    // this.finalMenuItems = _.cloneDeep(this.menuItems.getAll());
  }


  async signOut(): Promise<void> {
    const viewsMenu = _.find(this.menuItems.getAll(), (i: any): boolean => i.state === 'views');
    if (viewsMenu) { viewsMenu.children = []; }
    await this.authenticationService.logout();
  }

  setTwoFactorAuthentication(): void {
    const opts = _.merge({ data: { user: this.currentUser } }, ConfigService.getDialogConfigWide());
    this.dialog.open(TwoFaCodeComponent, opts);
  }

  isOver(): boolean {
    // if (this.url === '/apps/messages' || this.url === '/apps/calendar' || this.url === '/apps/media' || this.url === '/maps/leaflet') {
    //   return true;
    // } else {
    if (this.forceHideSideMenu) {
      return false;
    }
    return window.matchMedia('(max-width: 960px)').matches;
    // }
  }

  isMac(): boolean {
    let bool = false;
    // navigator.platform is not deprecated https://stackoverflow.com/questions/38506517/deprecated-javascript-os-detection-techniques
    // eslint-disable-next-line deprecation/deprecation
    const platform = navigator.platform.toUpperCase();
    if (platform.indexOf('MAC') >= 0 || platform.indexOf('IPAD') >= 0) {
      bool = true;
    }
    return bool;
  }

  menuMouseOver(): void {
    if (window.matchMedia('(min-width: 960px)').matches && this.collapseSidebar) {
      this.sidemenu.mode = 'over';
    }
  }

  menuMouseOut(): void {
    if (window.matchMedia('(min-width: 960px)').matches && this.collapseSidebar) {
      this.sidemenu.mode = 'side';
    }
  }

  menuToggleFunc(): void {
    this.sidemenu.toggle();
    this.collapsedClass = this.collapsedClass === 'side-panel-opened' ? 'side-panel-closed' : 'side-panel-opened';
    setTimeout((): boolean => window.dispatchEvent(new Event('resize')), 500);
    setTimeout((): boolean => window.dispatchEvent(new Event('resize')), 1000);
  }

  openDateRangePicker(e: any): void {
    const el: HTMLElement = document.getElementById('main-data-range-picker') as HTMLElement;
    setTimeout((): void => el.click(), 0);
    // toggle does not work
    // this.pickerDirective.toggle();
    // this.pickerDirective.open does not work
    // this.pickerDirective.open(e);
  }

  rangeClicked(range: any): void {
    // suppress the emittor for date range for some time
    this.enableDateRangeEventEmitter = false;
    // update the model
    this.selectedDateRange.startDate = this.configService.getDateRangePickerOptions(this.calendarSettings).ranges[range.label][0];
    this.selectedDateRange.endDate = this.configService.getDateRangePickerOptions(this.calendarSettings).ranges[range.label][1];
    const xpath = '//button[text()=\'Apply\']';
    const nativeElement = this.pickerDirective.viewContainerRef.element.nativeElement;
    const matchingElement = document.evaluate(xpath, nativeElement, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
    setTimeout((): void => (matchingElement as HTMLElement).click(), 0);
    this.pickerDirective.toggle();
    // console.log('AdminLayoutComponent :: [rangeClicked] range is : ', range, this.selectedDateRange.startDate.toISOString());
    const dr = new EventsServiceDateRange(this.selectedDateRange.startDate, this.selectedDateRange.endDate);
    this.eventsService.eventDateRangeLabelChanged(range.label, dr);
    // enable the emmitor if range is selected manually
    setTimeout((): boolean => this.enableDateRangeEventEmitter = true, 100);
  }

  datesUpdated(range: any): void {
    if (this.enableDateRangeEventEmitter) {
      // console.log('AdminLayoutComponent :: [datesUpdated] range is : ', range, this.selectedDateRange.startDate.toISOString());
      const dr = new EventsServiceDateRange(this.selectedDateRange.startDate, this.selectedDateRange.endDate);
      this.eventsService.emitDateRangeChanged(dr);
    }
  }

  showVideo(): void {
    this.candeMenuClicked = true;
    // const video = new Player('video', options);
    setTimeout((): void => {
      new Player('video');
    }, 500);

    // player.on('play', function() {
    //   console.log('played the video!');
    // });
  }
  navigateHome(): void {
    const route = this.getRoutePostLogin(this.menuItems, false);
    console.log('navigateHome', route);
    this.navigateTo(this.router, route);
  }
  // changeMenuLayout(value) {
  //   console.log(value)
  //   if (value) {
  //     this.menuLayout = 'top-menu';
  //   } else {
  //     this.menuLayout = 'vertical-menu';
  //     this.menuToggleFunc();
  //   }
  // }
  //
  // onSelectSidebarImage(selectedClass, event) {
  //   this.selectedSidebarImage = selectedClass;
  // }
  //
  // onSelectedSidebarColor(selectedClass) {
  //   this.selectedSidebarColor = selectedClass;
  // }
  //
  // onSelectedHeaderColor(selectedClass) {
  //   this.selectedHeaderColor = selectedClass;
  // }
  //
  // isBgActive(value) {
  //   if (value == this.selectedSidebarImage) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  //
  // isSidebarActive(value) {
  //   if (value == this.selectedSidebarColor) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  //
  // isHeaderActive(value) {
  //   if (value == this.selectedHeaderColor) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  // addMenuItem(): void {
  //   this.menuItems.add({
  //     state: 'menu',
  //     name: 'MENU',
  //     type: 'sub',
  //     icon: 'trending_flat',
  //     children: [
  //       {state: 'menu', name: 'MENU'},
  //       {state: 'timelmenuine', name: 'MENU'}
  //     ]
  //   });
  // }
}
